import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader } from "../components/PageHeader";
import { Loader, EmptyState, Btn } from "../components/Primitives";
import { StatusBadge } from "../components/Badges";
import { Radio, Clock } from "lucide-react";
import { toast } from "sonner";

export default function CertInReporting() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/breaches", { params: { limit: 200 } }).then(r => setItems(r.data.items || r.data)); }, []);

  const trigger = async (b) => {
    try {
      const { data } = await api.post(`/breaches/${b.id}/cert-in-report`);
      toast.success(`Generated: ${data.reference}`);
      const r = await api.get("/breaches", { params: { limit: 200 } }); setItems(r.data.items || r.data);
    } catch { toast.error("Failed"); }
  };

  if (!items) return <Loader />;

  return (
    <div>
      <PageHeader
        title="CERT-In Reporting"
        description="Parallel cyber incident reporting workflow with 6-hour target."
        testId="certin-page-header"
      />

      <div className="mb-4 border border-amber-200 bg-amber-50 rounded-md p-4 text-sm text-amber-900 flex gap-3 items-start">
        <Clock className="w-5 h-5 shrink-0 mt-0.5" />
        <div>
          <strong>CERT-In cyber incident reporting</strong> is required for a defined set of cyber incidents.
          The reporting target is <strong>6 hours</strong> of noticing / being brought to notice. This module runs in parallel with DPDP breach notifications.
        </div>
      </div>

      {items.length === 0 ? <EmptyState title="No breach cases" hint="CERT-In workflow is tied to Breach Command Center." /> : (
        <div className="bg-white border border-slate-200 rounded-md overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 border-b border-slate-200">
              <tr>{["Ref","Title","Category","CERT-In Status","Reference","Actions"].map(h => <th key={h} className="text-left px-4 py-2.5 text-[10px] font-bold uppercase tracking-[0.15em] text-slate-500">{h}</th>)}</tr>
            </thead>
            <tbody>
              {items.map((b) => (
                <tr key={b.id} className="border-b border-slate-100 hover:bg-slate-50">
                  <td className="px-4 py-2.5 font-medium">{b.breach_ref}</td>
                  <td className="px-4 py-2.5">{b.title}</td>
                  <td className="px-4 py-2.5">{b.incident_category}</td>
                  <td className="px-4 py-2.5"><StatusBadge status={b.cert_in_status || "not_started"} /></td>
                  <td className="px-4 py-2.5 text-[11px] text-slate-500">{b.cert_in_reference || "—"}</td>
                  <td className="px-4 py-2.5 text-right">
                    <Btn size="sm" variant="secondary" data-testid={`certin-generate-${b.id}`} onClick={() => trigger(b)}><Radio className="w-3.5 h-3.5" /> Generate</Btn>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
